module.exports = __webpack_public_path__ + "static/media/wash2.f780b3ab.jpg";